<template>
  <div class="detail-wrapper">
    <div class="prodet-bg">
      <div class="container" style="overflow: hidden">
        <div class="por-box-b">
          <div
            :title="item.specialName"
            class="por-boxb-a"
            :class="{ selected: currentSpecial.cstId === item.cstId }"
            v-for="(item, index) in specialList
              .filter((m) => m.type === 1 || m.type === 2)
              .slice(0, 8)"
            :key="index"
            @click="changeCourseSpecial(item)"
          >
            <span class="por-boxb-title">{{ item.specialName }}</span>
            <div class="por-boxb-expire" v-if="item.isExpire === 1">
              <img src="../../assets/images/mall/special-expire.png" />
            </div>
          </div>
          <div class="por-boxb-b" v-show="specialList.length > 8">
            <div class="por-boxb-title">
              <span>全部班型</span>
              <Icon type="md-arrow-dropdown" size="16" />
            </div>

            <ul class="por-boxb-list">
              <li
                v-for="(item, index) in specialList.filter(
                  (m) => m.type === 1 || m.type === 2
                )"
                :key="index"
              >
                <a
                  :title="item.specialName"
                  @click="changeCourseSpecial(item)"
                  >{{ item.specialName }}</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="prodet-player clearfix">
          <div class="prodet-player-lock" v-if="currentSpecial.isExpire === 1">
            <div class="podet-player-lock-icon">
              <Icon type="ios-lock" />
              <p>课程班型已过期</p>
            </div>
          </div>
          <div class="prodet-box-c">
            <video-player
              v-if="currentSpecial.type === 1"
              :width="800"
              :viewId="umcId"
              viewType="ppt"
              @on-over="playOver"
              @on-start="playStart"
              :loading="!isLoaded"
              page="study"
            ></video-player>
            <video-player
              v-else
              :width="800"
              :viewId="umcrId"
              viewType="review"
              @on-over="playOver"
              :loading="!isLoaded"
              page="study"
              :tipText="noVideoText"
            ></video-player>
          </div>
          <div class="prodet-box-d clearfix">
            <div class="prodet-boxd-a">
              <course-catalog v-if="currentSpecial.type === 1"></course-catalog>
              <review-catalog
                page="study"
                v-if="currentSpecial.type === 2"
              ></review-catalog>
            </div>
            <div class="prodet-boxd-b">
              <div class="prodet-pt-a active">
                <Icon custom="ich-icon ich-icon-catalog" />
                <p>视频</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 操作区域 -->
      <div class="container prodet-action clearfix">
        <div class="prodet-box-e" v-show="isBuy && isExistVideo">
          <span style="margin-right: 30px">
            <Icon custom="ich-icon ich-icon-play-rectangle" size="18" />
            播放
            <b class="color2">{{ videoPlayTimes }}</b> 次
          </span>
        </div>
      </div>
    </div>

    <div class="container clearfix" v-if="siteConfig.agencyId == 4274">
      <!-- 各类详情 -->
      <div class="product-detail">
        <div class="product-info-bar" ref="courseTop" data-key="1">
          课程介绍
        </div>
        <h3 class="product-info-title">
          {{ courseInfo.courseName }}
        </h3>
        <ul class="product-info-body">
          <li>
            <div class="info-item">
              <span>•</span>
              课程代码：
            </div>
            <div class="info-content">{{ courseInfo.courseNo }}</div>
          </li>
          <li></li>
          <li>
            <div class="info-item">
              <span>•</span>
              所属地区：
            </div>
            <div class="info-content">
              <em v-for="(item, index) in courseInfo.provinceList" :key="index">
                {{ item.name }} &nbsp;
              </em>
            </div>
          </li>
          <li>
            <div class="info-item">
              <span>•</span>
              考试时间：
            </div>
            <div class="info-content">
              <template
                v-if="
                  courseInfo.examTimeList && courseInfo.examTimeList.length > 0
                "
              >
                <p
                  v-for="(item, index) in courseInfo.examTimeList"
                  :key="index"
                >
                  <span>{{ item.province ? item.province : "------" }}</span>
                  <span style="margin-left: 30px">{{ item.examDate }}</span>
                  <span style="margin-left: 10px">
                    {{ item.startTime }}-{{ item.endTime }}
                  </span>
                </p>
              </template>
              <p v-else>待确定</p>
            </div>
          </li>
        </ul>
        <h4 class="product-info-sub">包含班型：</h4>
        <div class="product-course-list">
          <dl>
            <dd v-for="(special, speIndex) in specialList" :key="speIndex">
              {{ special.specialName }}
            </dd>
          </dl>
        </div>

        <h4 class="product-info-sub">包含课程视频：</h4>
        <ul
          class="product-info-body col1"
          v-if="courseInfo.courseSpecialTypesByCourse"
        >
          <li v-for="(item, index) in specialStatisticsWithVideo" :key="index">
            <div class="info-item">
              <span>•</span>
              {{ item.specialName }}：
            </div>
            <div class="info-content">
              <span>
                课时：
                <b class="color2">{{ item.pptTime }}</b>
                分钟
              </span>
              <span>
                视频：
                <b class="color2">{{ item.pptNum }}</b>
                个
              </span>
              <span v-if="siteConfig.isShowProductValid == 1">
                有效期：{{ item.endTime }}
              </span>
            </div>
          </li>
        </ul>

        <h4 class="product-info-sub">包含课程题库：</h4>
        <ul
          class="product-info-body col1"
          v-if="courseInfo.courseSpecialTypesByCourse"
        >
          <li
            v-for="(item, index) in specialStatisticsWithExercise"
            :key="index"
          >
            <div class="info-item">
              <span>•</span>
              {{ item.specialName }}：
            </div>
            <!-- <div v-if="item.specialType === 3" class="info-content">
              <span
                ><b class="color2">{{ item.exerNum }}</b> 题</span
              >
            </div> -->
            <div v-if="item.specialType === 4" class="info-content">
              <span>
                <b class="color2">{{ item.simExamAmountNum }}</b>
                题
                <b class="color2">{{ item.simExamItem }}</b>
                套
              </span>
              <span v-if="siteConfig.isShowProductValid == 1">
                有效期：{{ item.endTime }}
              </span>
            </div>
            <div v-else class="info-content">
              <span>
                <b class="color2">{{ item.exerNum }}</b>
                题
              </span>
              <span v-if="siteConfig.isShowProductValid == 1">
                有效期：{{ item.endTime }}
              </span>
            </div>
          </li>
        </ul>
        <h4 class="product-info-sub">使用教材</h4>
        <div class="product-info-textbook">
          <div class="product-info-center">
            <div class="textbook-img">
              <img
                :src="concatImageUrl(courseInfo.coverPic, 68, 98)"
                alt="教材名称"
                style="width: 68px; height: 98px"
                v-if="courseInfo.coverPic"
              />
              <img v-else src="../../assets/images/v3/material-default.png" />
            </div>
            <div class="textbook-info">
              <div class="textbook-name">
                <Tooltip :content="`《${item.matName}》`" max-width="400" placement="top-start">
                  <div class="textbook-name-in">
                    《{{ item.matName }}》
                  </div>
                </Tooltip>
              </div>
              <span>
                <b>主编：</b>
                {{ courseInfo.writer }}
              </span>
              <br />
              <span>
                <b>版次：</b>
                {{ courseInfo.pubNo }}
              </span>
              <span>
                <b>出版社：</b>
                {{ courseInfo.pubName }}
              </span>
            </div>
          </div>
          <div class="product-info-line"></div>
          <div class="product-info-center">
            <div class="textbook-img">
              <img
                :src="concatImageUrl(courseInfo.coverPic, 68, 98)"
                alt="教材名称"
                style="width: 68px; height: 98px"
                v-if="courseInfo.coverPic"
              />
              <img v-else src="../../assets/images/v3/material-default.png" />
            </div>
            <div class="textbook-info">
              <div class="textbook-name">《{{ courseInfo.matName }}》</div>
              <span>
                <b>主编：</b>
                {{ courseInfo.writer }}
              </span>
              <br />
              <span>
                <b>版次：</b>
                {{ courseInfo.pubNo }}
              </span>
              <span>
                <b>出版社：</b>
                {{ courseInfo.pubName }}
              </span>
            </div>
          </div>
        </div>
        <div
          style="padding-top: 20px; font-size: 16px; line-height: 30px"
          v-html="courseInfo.brief"
        ></div>
      </div>
      <!-- 侧边栏 -->
      <div class="product-sider">
        <div class="product-info-bar">师资简介</div>
        <teacher-slider :dataList="courseInfo.teacherList"></teacher-slider>
      </div>
    </div>

    <!-- 统计 -->
    <div class="study-module" v-if="siteConfig.agencyId == 4274">
      <div class="product-info-bar" ref="statisticsTop" data-key="4">
        学习统计
      </div>
      <div class="product-info-bar-en">
        <img src="../../assets/images/v3/product-detail-title-en03.png" />
      </div>
      <study-statistics v-if="courseLoaded"></study-statistics>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "../../components/common/VideoPlayer";
import CourseCatalog from "../../components/mall/CourseCatalog";
import ReviewCatalog from "../../components/mall/ReviewCatalog";
import TeacherSlider from "../../components/mall/TeacherSlider";
import StudyStatistics from "../../components/mall/study/StudyStatistics";

import { siteMixin } from "../../utils/mixin";
import { mall, study } from "../../request";

export default {
  mixins: [siteMixin],
  data() {
    return {
      refreshComponent: true,
      umcrId: 0,
      specialList: [],
      currentSpecial: {}, //当前班型
      noVideoText: "",
      courseInfo: {
        teacherList: [],
      },
      courseLoaded: false,
      specialStatisticsWithVideo: [],
      specialStatisticsWithExercise: [],
      isExistVideo: true,
      videoPlayTimes: 0,
      isLoaded: false,
    };
  },
  watch: {
    pptId() {
      this.getPlayTimes();
    },
  },
  mounted() {
    this.initCourseData();
  },
  methods: {
    initCourseData() {
      const courseId = this.$route.params.cid;
      //if(!courseId) this.$router.push(); 跳转到错误页
      this.setCourseId(courseId);
      this.getCourseSpecialType();
      this.getCourseInfo();
    },
    //获取用户课程班型
    getCourseSpecialType() {
      study
        .getCourseSpecial(this.courseId, this.loginUser.userId)
        //.getCourseSpecial("9-1241235r31513121", 14868)
        .then((res) => {
          //console.log("courseSpecial", res);
          if (res.status === 1) {
            if (res.data && res.data.length > 0) {
              this.specialList = res.data;

              //初始化默认班型数据（以有视频的优先，否则取第一个）
              const existVideoSpecial = this.specialList.find(
                (m) => m.isHasVideo && m.isHasVideo === 1
              );
              if (existVideoSpecial) {
                this.currentSpecial = existVideoSpecial;
              } else {
                this.currentSpecial = this.specialList[0];
              }
              this.setCourseSpecialId(this.currentSpecial.cstId);
              this.setUmcId(this.currentSpecial.umcId);
              this.getCourseCatalogWithStudy();
            }
          }
        });
    },
    //获取课程信息，及用户是否购买过当前课程，以及获取课程目录
    getCourseInfo() {
      mall
        .getCourseInfo(
          this.courseId,
          this.loginUser.userId,
          this.siteConfig.agencyId
        )
        .then((res) => {
          //console.log("courseInfo", res);
          if (res.status === 1) {
            this.courseInfo = res.data;

            //处理班型统计数据
            if (this.courseInfo) {
              this.specialStatisticsWithVideo =
                this.courseInfo.courseSpecialTypesByCourse.filter(
                  (m) => m.specialType === 1
                );
              const a = this.courseInfo.courseSpecialTypesByCourse.filter(
                (m) => m.specialType === 3
              );
              const b = this.courseInfo.courseSpecialTypesByCourse.filter(
                (m) => m.specialType === 4
              );
              const c = this.courseInfo.courseSpecialTypesByCourse.filter(
                (m) => m.specialType === 2
              );
              this.specialStatisticsWithExercise = [...a, ...b, ...c];
            }
            this.setIsBuy(this.courseInfo.isBuy == 0 ? false : true);
            this.setMetaData(this.courseInfo.courseName);

            this.courseLoaded = true;
          }
        });
    },
    changeCourseSpecial(item) {
      if (item.cstId == this.currentSpecial.cstId) return;
      this.currentSpecial = item;
      this.setCourseSpecialId(this.currentSpecial.cstId);
      this.setUmcId(item.umcId);
      this.getCourseCatalogWithStudy();
      this.refreshComponent = false;
      this.$nextTick(() => {
        this.refreshComponent = true;
      });
    },
    //获取课程目录（已购买，包括章节学习统计信息）
    getCourseCatalogWithStudy() {
      //this.isLoaded = false;
      study
        .getCourseCatalog(
          this.umcId,
          this.courseId,
          this.currentSpecial.cstId,
          this.currentSpecial.type
        )
        .then((res) => {
          //console.log("catalog", res);
          if (res.status === 1) {
            this.isLoaded = true;
            if (!res.data || res.data.length == 0) {
              this.setCourseCatalog([]);
              this.setPptId("");
              this.setVideoId("");
              this.isExistVideo = false;
              if (this.currentSpecial.type === 2) {
                this.noVideoText = "该班型视频正在准备中";
              }
            }
            //章节
            if (this.currentSpecial.type === 1) {
              this.setCourseCatalog(res.data);
              //查找并设置视频ID
              if (res.data.length > 0) {
                const one = res.data[0];
                if (one.childList && one.childList.length > 0) {
                  const two = one.childList[0];
                  if (two.childList && two.childList.length > 0) {
                    const three = two.childList[0];
                    if (three.isTryLook == 1) {
                      this.setPptId(three.pptId);
                      this.setVideoId(three.bVideoId);
                      this.setCatalogId(three.catId);
                      this.isExistVideo = true;
                    } else {
                      this.setPptId("");
                      this.setVideoId("");
                      this.isExistVideo = false;
                    }
                  }
                }
              }
            }
            //串讲
            if (
              this.currentSpecial.type === 2 &&
              res.data &&
              res.data.length > 0
            ) {
              this.umcrId = res.data[0].umcrId;
              const reviewPptList = res.data[0].pptList || [];
              const liveList = res.data[0].live|| [];
              let resultList = [];
              if (reviewPptList && reviewPptList.length) {
                resultList = reviewPptList.map((m) => {
                  return {
                    type: 1,
                    ...m,
                  };
                });
              }
              if (liveList && liveList.length) {
                const liveTemp = liveList.map((m) => {
                  return {
                    type: 2,
                    isTryLook: 0,
                    ...m,
                  };
                });
                resultList = [...resultList, ...liveTemp];
              }
              if (resultList && resultList.length > 0) {
                
                this.setReviewCatalog(resultList);
                let current = reviewPptList[0];
                if (current.isTryLook === 1) {
                  this.setPptId(current.PptId);
                  this.setVideoId(current.bVideoId);
                  this.setReviewPositionName(current.PptName);
                } else {
                  this.setPptId("");
                  this.setVideoId("");
                  this.isExistVideo = false;
                }
              }
            }
          }
        });
    },
    //获取播放次数
    getPlayTimes() {
      if (
        this.umcId > 0 &&
        this.currentSpecial.type == 1 &&
        this.catalogId > 0
      ) {
        study.getVideoPlayInfo(this.umcId, this.catalogId).then((res) => {
          //console.log(res);
          if (res.status === 1) {
            this.videoPlayTimes = res.data[0].pptTimes;
          }
        });
      }
      if (this.umcId > 0 && this.currentSpecial.type == 2 && this.umcrId > 0) {
        study.getReviewPlayInfo(this.umcrId, this.pptId).then((res) => {
          //console.log("reviewPlayTimes", res);
          if (res.status === 1) {
            this.videoPlayTimes = res.data.pptTimes;
          }
        });
      }
    },
    playStart() {
      console.log("videoStart", this.umcId, this.catalogId);
      if (this.currentSpecial.type === 1) {
        study
          .setVideoPlayOverWithPpt(this.umcId, this.catalogId)
          .then((res) => {
            console.log("videoStartEnd", res);
          });
      }
    },
    playOver() {
      console.log("playOver", this.umcId, this.catalogId);
      if (this.currentSpecial.type === 1) {
        study
          .setVideoPlayOverWithPpt(this.umcId, this.catalogId, 1)
          .then((res) => {
            console.log("playOverEnd", res);
          });
      }
      //串讲
      if (this.currentSpecial.type === 2) {
        study
          .setVideoPlayOverWithReview(this.umcrId || 0, this.pptId)
          .then((res) => {
            console.log(res);
          });
      }
    },
  },
  components: {
    VideoPlayer,
    CourseCatalog,
    ReviewCatalog,
    TeacherSlider,
    StudyStatistics,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
.detail-wrapper {
  background: url("../../assets/images/v3/product-detail-bg.png") repeat-y
    center bottom;
}
//播放位置
.prodet-bg {
  background: #2f3133 url("../../assets/images/v3/player-bg-p.png") repeat-y
    center bottom;
  width: 100%;
  padding-top: 20px;
  .por-box-location {
    height: 70px;
    line-height: 70px;
    color: #999;
    font-size: 16px;
    i {
      vertical-align: -0.08em;
    }
    span {
      .inline-block();
      margin-left: 10px;
      & > span {
        height: 26px;
        line-height: 26px;
        padding: 0 12px;
        border-radius: 4px;
        vertical-align: 0.08em;
        .background-primary();
      }
    }
  }
  .por-box-b {
    width: 100%;
    height: 50px;
    background: #1b1b1b;
    .por-boxb-a {
      position: relative;
      width: 130px;
      height: 50px;
      font-size: 16px;
      text-align: center;
      float: left;
      border-right: 1px solid #272727;
      margin-left: -1px;
      &:hover,
      &.selected {
        .background-primary();
      }
      .por-boxb-title {
        display: block;
        width: 100%;
        height: 50px;
        line-height: 50px;
        color: white;
        .ellipsis();
        padding: 0 10px;
        cursor: pointer;
      }
      .por-boxb-expire {
        position: absolute;
        right: 0;
        top: -20px;
      }
    }
    .por-boxb-b {
      float: right;
      text-align: center;
      position: relative;
      height: 60px;
      padding-right: 12px;
      .por-boxb-title {
        margin-top: 12px;
        height: 36px;
        line-height: 34px;
        border: 1px solid #bbbbbb;
        background-color: #4e4e4e;
        color: white;
        font-size: 14px;
        cursor: pointer;
        padding-right: 5px;
        span {
          width: 100px;
          padding-left: 5px;
          .inline-block();
          .ellipsis();
        }
      }
      .por-boxb-list {
        position: absolute;
        background-color: #1b1b1b;
        width: 325px;
        top: 60px;
        right: -325px;
        height: 500px;
        z-index: 100;
        overflow-y: auto;
        .transTime(0.2s);
        li {
          height: 50px;
          line-height: 50px;
          width: 100%;
          padding: 0 20px;
          &:hover,
          &.selected {
            .background-primary();
          }
          & > a {
            display: block;
            color: #fff;
            text-align: left;
            font-size: 16px;
            .ellipsis();
          }
        }
      }
      &:hover {
        .por-boxb-title {
          border: 1px solid transparent;
          background: linear-gradient(to right, #349eee, #6f98f9);
        }
        .por-boxb-list {
          right: 0;
        }
      }
    }
  }
  .prodet-player {
    width: 100%;
    position: relative;
    .prodet-player-lock {
      position: absolute;
      left: 0;
      right: 0;
      width: 1125px;
      height: 100%;
      background: rgba(0, 0, 0, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 500;
      .podet-player-lock-icon {
        font-size: 60px;
        color: #fff;
        text-align: center;
        p {
          font-size: 20px;
        }
      }
    }
    .prodet-box-c {
      float: left;
      width: 800px;
      height: 500px;
      background: #e4ebef;
    }
    .prodet-box-d {
      float: left;
      width: 400px;
      height: 500px;
      background: #1f2123;
      .prodet-boxd-a {
        float: left;
        width: 336px;
        height: 500px;
        padding: 12px 0 11px 0;
      }
      .prodet-boxd-b {
        width: 64px;
        height: 500px;
        float: right;
        background: #000;
        position: relative;
        .prodet-pt-a {
          position: relative;
          width: 64px;
          height: 64px;
          padding: 10px 0;
          text-align: center;
          color: #fff;
          margin-bottom: 2px;
          cursor: pointer;
          a {
            color: #fff;
          }
          i {
            width: 26px;
            height: 26px;
            padding: 2px 0;
            font-size: 22px;
          }
          p {
            font-weight: bold;
            font-size: 12px;
          }
          &:hover {
            .background-primary();
          }
          &.active {
            .background-primary();
            &:before {
              position: absolute;
              content: " ";
              border: 8px solid transparent;
              border-right: 8px solid #27a3ff;
              bottom: 25px;
              left: -16px;
            }
          }
        }
      }
    }
  }
  .prodet-action {
    padding: 10px 0;
    .prodet-box-e {
      width: 500px;
      height: 40px;
      line-height: 40px;
      span {
        .inline-block();
        cursor: pointer;
        color: #fff;
        &.active {
          color: #27a3ff;
        }
        abbr {
          margin-left: 2px;
        }
        i {
          vertical-align: -0.1em;
          margin-right: 3px;
        }
      }
    }
    .prodet-box-f {
      width: 900px;
      height: 40px;
      float: right;
      text-align: right;
      .product-buy-class {
        float: left;
        width: 480px;
        text-align: right;
        margin-right: 30px;
        span {
          width: 120px;
          height: 40px;
          border: 1px solid #fff;
          line-height: 40px;
          font-size: 16px;
          text-align: center;
          margin-right: 15px;
          border-radius: 4px;
          color: #fff;
          cursor: pointer;
          display: inline-block;
          position: relative;
          z-index: 2;
          background-color: #2f3133;
          &.selected,
          &:not(.disabled):hover {
            border-color: #ff6a00;
            color: #ff6a00;
          }
        }
        .product-buy-class-tips {
          position: absolute;
          top: -25px;
          right: 15px;
          z-index: 1;
          color: #eb5025;
          font-size: 14px;
          text-align: center;
          width: 100px;
          height: 39px;
          display: block;
          background: url("../../assets/images/mall/review-tips.png") no-repeat;
        }
      }
      .prodet-boxf-c {
        float: left;
        margin-right: 32px;
        color: #fd9801;
        font-size: 32px;
      }
      .prodet-boxf-b {
        font-size: 1.6rem;
        color: #fff;
        display: block;
        float: left;
        line-height: 40px;
        margin-right: 32px;
        text-decoration: line-through;
        margin-top: 10px;
      }
    }
  }
}
// 通用标题
.product-info-bar {
  width: 200px;
  height: 40px;
  line-height: 40px;
  background: url("../../assets/images/v3/product-detail-title.png") no-repeat
    left center;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  text-indent: 1em;
  &-en {
    position: absolute;
    top: 30px;
    right: 12px;
  }
}

// 商品详情内容
.product-detail {
  width: 800px;
  background: white;
  float: left;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 20px 30px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

  .product-info-bar {
    margin-left: -30px;
  }
  .product-info-title {
    padding: 30px 0 10px 0;
    font-size: 22px;
    color: #414141;
  }
  .product-info-sub {
    padding: 30px 0 10px 0;
    font-size: 18px;
    color: #666;
  }
  .product-info-body {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding-bottom: 20px;
    border-bottom: 1px dashed #ddd;
    &.col1 {
      li {
        width: 100%;
      }
    }
    li {
      width: 50%;
      color: #666;
      font-size: 16px;
      display: flex;
      margin: 5px 0;
      .info-item {
        span {
          font-size: 22px;
          color: #999;
          line-height: 1;
          vertical-align: -0.1em;
        }
      }
      .info-content {
        flex: 1;
        em {
          font-style: normal;
        }
        span {
          display: inline-block;
          color: #999;
          margin-right: 10px;
        }
        & > span {
          min-width: 160px;
        }
      }
    }
  }
  .product-course-list {
    border-bottom: 1px dashed #ddd;
    dl {
      dt {
        font-weight: bold;
        color: #666;
        font-size: 16px;
      }
      dd {
        display: inline-block;
        margin-right: 20px;
        margin-top: 5px;
        margin-bottom: 20px;
        color: #666;
        font-size: 16px;
      }
    }
  }
  .product-info-textbook {
    font-size: 16px;
    border-bottom: 1px dashed #ddd;
    padding-bottom: 20px;
    .product-info-center {
      display: flex;
    }
    .product-info-line {
      width: 100%;
      height: 1px;
      background-color: #eee;
      margin: 18px 0;
    }
    .textbook-img {
      width: 80px;
      height: 100px;
    }
    .textbook-info {
      color: #999;
      flex: 1;
      .textbook-name {
        font-size: 20px;
        color: #666;
        margin-bottom: 6px;
        .textbook-name-in{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      span {
        font-size: 16px;
        line-height: 2;
        margin-left: 8px;
        margin-right: 50px;
      }
    }
  }
  .product-info-detail {
    margin-top: 30px;
    text-align: center;
    width: 100%;
    /deep/img {
      display: inline-block;
    }
  }
}
//侧边栏
.product-sider {
  width: 370px;
  float: right;
  background: #fff;
  margin-top: 30px;
  padding: 20px 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  .product-info-bar {
    margin-left: -10px;
    margin-bottom: 30px;
  }
}
//各模块容器
.study-module {
  position: relative;
  width: 1200px;
  margin: 0 auto 30px auto;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  padding: 20px 30px;
  .product-info-bar {
    margin-left: -30px;
    margin-bottom: 20px;
  }
}
</style>
